import React from 'react';
import { Form, TabPanel, TabsHeader, useTabsState } from '../../toolympus/components/primitives';
import { DictionariesList } from '../../toolympus/components/Dictionaries/DictionariesList';
import { DecisionBodyList, TopicList } from './Dictionaries';

interface Props {
  
}

const HiddenDictionaries = [
  "topics",
  "users",
  "decisionbody",
];

export const AllDictionariesPage = (props: Props) => {
  const tabs = useTabsState([
    ["dictionaries","Dictionaries"],
    ["decisionbody","Organs"],
    ["topics","Topics"],
  ], "dictionaries", undefined, "__biodev_dicts_tab");

  return (
    <Form>
        <TabsHeader state={tabs} noMargin />
        
        <TabPanel state={tabs.forTab("dictionaries")}>
          <DictionariesList apiPath="/api/settings/dictionaries" hideDictionaries={HiddenDictionaries} />
        </TabPanel>

        <TabPanel state={tabs.forTab("decisionbody")}>
          <DecisionBodyList />
        </TabPanel>


        <TabPanel state={tabs.forTab("topics")}>
          <TopicList />
        </TabPanel>
    </Form>
  );
}
